module.exports = __webpack_public_path__ + "img/wardInfoRedBrown.79953bac.svg";